
export const makeRequestId = ({
  fn = 'op',
  userId = '0',
  stamp = Date.now().toString(),
}) => `${stamp}.${userId}.${fn}`;
